const getStatusColorReg = {
    methods: {
        getStatusColorReg(status) {
            return status === "open" ? "openStatus" : status === "closed" ? "closedStatus" : "";
        }
    }
}

export { getStatusColorReg }